import { render, staticRenderFns } from "./LandingPageBooks.vue?vue&type=template&id=4a01ef08&scoped=true&"
import script from "./LandingPageBooks.vue?vue&type=script&lang=js&"
export * from "./LandingPageBooks.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageBooks.vue?vue&type=style&index=0&id=4a01ef08&prod&scoped=true&lang=css&"
import style1 from "./LandingPageBooks.vue?vue&type=style&index=1&id=4a01ef08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a01ef08",
  null
  
)

export default component.exports